export const IMAGES_TO_PRELOAD = [
'/images/slider/light/close.png',
'/images/exhibitions/about_apta.jpg',
'/images/exhibitions/about_bond_between.jpg',
'/images/exhibitions/about_courtyards.jpg',
'/images/exhibitions/about_myths.jpg',
'/images/exhibitions/apta.jpg',
'/images/exhibitions/bond_between.jpg',
'/images/exhibitions/courtyards.jpg',
'/images/exhibitions/icons/active/backArrow.png',
'/images/exhibitions/icons/backArrow.png',
'/images/exhibitions/icons/hover/backArrow.png',
'/images/exhibitions/mobile/apta.jpg',
'/images/exhibitions/mobile/bond_between.jpg',
'/images/exhibitions/mobile/courtyards.jpg',
'/images/exhibitions/mobile/myths.jpg',
'/images/exhibitions/myths.jpg',
'/images/gallery/big/armaturacrucis.jpg',
'/images/gallery/big/armaturapater.jpg',
'/images/gallery/big/clews_of_destinies.jpg',
'/images/gallery/big/crescent_moon_of_thoughts.jpg',
'/images/gallery/big/dance_of_the_atlanteans.jpg',
'/images/gallery/big/dryad_of_spring.jpg',
'/images/gallery/big/the_key_of_understanding.jpg',
'/images/gallery/big/young_growth.jpg',
'/images/gallery/desktop/armaturacrucis.png',
'/images/gallery/desktop/armaturapater.png',
'/images/gallery/desktop/clews_of_destinies.png',
'/images/gallery/desktop/crescent_moon_of_thoughts.png',
'/images/gallery/desktop/dance_of_the_atlanteans.png',
'/images/gallery/desktop/dryad_of_spring.png',
'/images/gallery/desktop/the_key_of_understanding.png',
'/images/gallery/desktop/young_growth.png',
'/images/gallery/mobil/armaturacrucis.jpg',
'/images/gallery/mobil/armaturapater.jpg',
'/images/gallery/mobil/clews_of_destinies.jpg',
'/images/gallery/mobil/crescent_moon_of_thoughts.jpg',
'/images/gallery/mobil/dance_of_the_atlanteans.jpg',
'/images/gallery/mobil/dryad_of_spring.jpg',
'/images/gallery/mobil/the_key_of_understanding.jpg',
'/images/gallery/mobil/young_growth.png',
'/images/global/active/angle.png',
'/images/global/active/close.png',
'/images/global/angle.png',
'/images/global/checkbox.png',
'/images/global/checked/checkbox.png',
'/images/global/checked/radiobutton.png',
'/images/global/close.png',
'/images/global/correct.png',
'/images/global/hover/angle.png',
'/images/global/hover/checkbox.png',
'/images/global/hover/close.png',
'/images/global/hover/radiobutton.png',
'/images/global/incorrect.png',
'/images/global/radiobutton.png',
'/images/home/about/about_1.jpg',
'/images/home/about/about_3.jpg',
'/images/home/about/about_5.jpg',
'/images/home/about/mobil_about_1.jpg',
'/images/home/about/mobil_about_3.jpg',
'/images/home/about/mobil_about_5.jpg',
'/images/home/exhibition.jpg',
'/images/home/exhibition_mobil.jpg',
'/images/slider/light/active/close.png',
'/images/slider/light/active/minus.png',
'/images/slider/light/active/mobil_vertical_angle_arrow.png',
'/images/slider/light/active/play.png',
'/images/slider/light/active/plus.png',
'/images/slider/light/active/stop.png',
'/images/slider/light/active/vertical_angle_arrow.png',
'/images/slider/light/close.png',
'/images/slider/light/hover/close.png',
'/images/slider/light/hover/minus.png',
'/images/slider/light/hover/play.png',
'/images/slider/light/hover/plus.png',
'/images/slider/light/hover/stop.png',
'/images/slider/light/hover/vertical_angle_arrow.png',
'/images/slider/light/minus.png',
'/images/slider/light/mobil_vertical_angle_arrow.png',
'/images/slider/light/play.png',
'/images/slider/light/plus.png',
'/images/slider/light/stop.png',
'/images/slider/light/vertical_angle_arrow.png',
'/images/slider/red/active/close.png',
'/images/slider/red/active/minus.png',
'/images/slider/red/active/mobil_vertical_angle_arrow.png',
'/images/slider/red/active/play.png',
'/images/slider/red/active/plus.png',
'/images/slider/red/active/stop.png',
'/images/slider/red/active/vertical_angle_arrow.png',
'/images/slider/red/close.png',
'/images/slider/red/hover/close.png',
'/images/slider/red/hover/minus.png',
'/images/slider/red/hover/play.png',
'/images/slider/red/hover/plus.png',
'/images/slider/red/hover/stop.png',
'/images/slider/red/hover/vertical_angle_arrow.png',
'/images/slider/red/minus.png',
'/images/slider/red/mobil_vertical_angle_arrow.png',
'/images/slider/red/play.png',
'/images/slider/red/plus.png',
'/images/slider/red/stop.png',
'/images/slider/red/vertical_angle_arrow.png',
'/images/tamara/big/a_tower_of_thoughts.jpg',
'/images/tamara/big/batleyka.jpg',
'/images/tamara/big/blagovest.jpg',
'/images/tamara/big/dzyadi.jpg',
'/images/tamara/big/ivan.jpg',
'/images/tamara/big/loanll.jpg',
'/images/tamara/big/pakrov.jpg',
'/images/tamara/big/venice.jpg',
'/images/tamara/desktop/a_tower_of_thoughts.png',
'/images/tamara/desktop/batleyka.png',
'/images/tamara/desktop/blagovest.png',
'/images/tamara/desktop/dzyadi.png',
'/images/tamara/desktop/ivan.png',
'/images/tamara/desktop/loanll.png',
'/images/tamara/desktop/pakrov.png',
'/images/tamara/desktop/venice.png',
'/images/tamara/mobil/a_tower_of_thoughts.jpg',
'/images/tamara/mobil/batleyka.jpg',
'/images/tamara/mobil/blagovest.jpg',
'/images/tamara/mobil/dzyadi.jpg',
'/images/tamara/mobil/ivan.jpg',
'/images/tamara/mobil/loanll.jpg',
'/images/tamara/mobil/pakrov.jpg',
'/images/tamara/mobil/venice.jpg'
];